import styled from "styled-components"

export const FeatureColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  align-items: stretch;
  @media (max-width: 1199px) { gap: 24px; }
  @media (max-width: 991px) { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px; }
  @media (max-width: 575px) { grid-template-columns: 1fr; gap: 16px; }
`

export const FeatureColumn = styled.div`
  min-width: 0;
  .features-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
    animation-delay: ${props => props.index * 50}ms;
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .features-column-title {
    font-size: 19px;
    line-height: 1.35;
    margin: 0;
    color: #23272c;
    text-align: start;
    letter-spacing: -0.01em;
    font-weight: 600;
    transition: color 0.35s ease;
  }
  .features-column-text {
    font-size: 14px;
    line-height: 1.8;
    margin: 0 0 18px;
    flex-grow: 1;
    text-align: justify;
    text-align-last: start;
    hyphens: auto;
    -webkit-hyphens: auto;
    color: #606d7e;
    transition: color 0.35s ease;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  svg path { transition: all 0.35s ease-in-out; }
  @media (max-width: 991px) {
    .features-column-title { font-size: 17px; }
    .features-column-text { font-size: 13px; margin-bottom: 16px; }
  }
  @media (max-width: 575px) {
    .features-column-title { font-size: 15px; }
    .features-column-text { font-size: 12px; margin-bottom: 14px; }
  }
`